import type { ReactNode } from "react";

const SCRIBBLE_PATH = "M2 9 C 30 2, 70 13, 110 6 S 180 11, 198 5";

const STROKE: Record<string, string> = {
  lime: "var(--color-lime)",
  "lime-dark": "var(--color-lime-dark)",
  ink: "var(--color-ink)",
};

export function Scribble({
  children,
  tone = "lime-dark",
}: {
  children: ReactNode;
  tone?: "lime" | "lime-dark" | "ink";
}) {
  return (
    <span className="scribble-under">
      <span>{children}</span>
      <svg viewBox="0 0 200 14" preserveAspectRatio="none" aria-hidden="true">
        <path
          d={SCRIBBLE_PATH}
          fill="none"
          strokeWidth={6}
          strokeLinecap="round"
          stroke={STROKE[tone]}
        />
      </svg>
    </span>
  );
}
